/**
 * Getters for wordpress/account module
 */
const getters = {
  id: state => state.id,
  url: state => state.url,
  username: state => state.username,
  password: state => state.password,
  isLoggedIn: state => state.token !== '' && state.id !== '' && state.email !== '',
  authorizationHeader: state => `Bearer ${state.token}`
}

export default getters



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/account/getters.js